export const faq = [
  {
    question: "How the app can be downloaded?",
    answer:
      "The application is available on Google Play Store by the name of “HUM BEE TEAM” and can be downloaded from the same.",
  },
  {
    question: "Who can use this APP?",
    answer:
      "The application HUMBEE can be used by Dealers & Retailers.Our mobile app is supported on the following platforms, Android",
  },
  {
    question: "Is the mobile app secure?",
    answer:
      "Yes! All critical information is encrypted on the app The application HUMBEE is a 100% secured application.",
  },
  {
    question: "How Can a dealer Register on APP?",
    answer: `There are two steps to register on HUMBEE App: 
        i.	The dealer needs to register his Mobile Number through a One Time Password (OTP).
        ii.	The dealer needs to fill some necessary details which includes:
        a.	First Name 
        b.	Select the  Option to  be  registered  as “DEALER “.
        c.	Association with Cement Companies as a Dealer 
        d.	GSTN number: Compulsory Field 
        e.	PAN number: compulsory field 
        Post that the application is ready for the  use.
        `,
  },
  {
    question: "How a Dealer Can Upload his Inventory?",
    answer: `Dealer can upload his inventory by uploading the invoice/bill, received post purchase from the cement companies, on the HUMBEE app
        -	Post this,  inventory will be approved by  verifying  quantity on the app with the invoice uploaded.`,
  },
  {
    question: "Can we upload the invoice of different companies?",
    answer: `Yes! all the cement companies invoices/bills can be uploaded on the app
        -	The users have to Select  companies and product under the invoice uploaded on the app`,
  },
  {
    question: "How a Dealer can register a Retailer?",
    answer: `A dealer can register a Retailer by following simple steps:
        The users have to Select  companies and product under the invoice uploaded on the app
        1.	Under the home tab, go to “Sell to Retailer” tab and search for the concerned Retailer through his/her mobile number.
        2.	If the Retailer is already registered on the app HUMBEE, the dealer can upload the invoice.
        3.	If the Retailer hasn’t been registered on the app HUMBEE. Through normal information of Mobile No. & Pan Details of the concerned Retailer, He/she can be registered on the HUMBEE app
        4.	Post entering these details, an OTP will be generated and the dealer can register the Retailer.
        5.	Pan Card is compulsory for retailers 
        `,
  },
  {
    question: "How Dealer can sell to Retailers?",
    answer: `A dealer can sell to Retailers by:
        The users have to Select  companies and product under the invoice uploaded on the app
        1.	Searching the Retailer through their mobile numbers.
    2.	If the Retailer exits on the HUMBEE app, the dealer needs to upload his invoice that he has supplied to the Retailer along with the details of the Cement company and Brand.
    3.	Post that the Retailer inventory will be uploaded on their concerned account.
        `,
  },
  {
    question: "How a Dealer/Retailer Can sell to Shilpkaar.",
    answer: `A dealer/Retailer  can sell to a Shilpkar by:
        1.	Searching the Shilpkaar through their mobile numbers.
    2.	If the concerned Shilpkaar exists on the HUM BEE application, the dealer needs to upload the quantity he wants to sell to the Shilpkaar. (In this operation the dealer doesn’t needs to update the inventory).
    3.	If the Shilpkaar is not registered on the HUM BEE application, by uploading few details like Id Proof (Driving license id/ voter id / ration card / bank- passbook) and the Shilpkar’ s picture.
    4.	Post that the application will generate an OTP and will send to the Shilpkar’ s registered mobile number for registration on the HUM BEE application.
        `,
  },
  {
    question: "Can a Retailer download the app?",
    answer: `Yes! Retailer can download the app & register through their mobile number and  OTP will be generated. Using the OTP Retailer shall Login and  select the option as a Retailer.  
        The he has to provide in with some basic details which includes:
        i.	Name
    ii.	FIRM Name
    iii. PAN Details: Compulsory Field 
    iv.	And then upload the PAN details.
        `,
  },
  {
    question: "Can Retailers upload their own invoice?",
    answer: `No, the Retailers cannot upload their own invoice, invoices should be uploaded only by dealer.
        `,
  },
  {
    question: "Can Retailer register the Shilpkar?",
    answer: `Yes Retailer can register the Shilpkaar.
        `,
  },
  {
    question:
      "If I’m the dealer of one company & Retailer of another company how I can register on app?",
    answer: `In this case, you can register on the app HUMBEE by selecting Dealer.
        -	All the invoices purchased by company, upload in the APP &  it is  shown as a dealer .
        -	If you are also a Retailer, Pls use the same login credentials and then your dealers need to upload the invoices purchased by you on the dealer application. 
        `,
  },
  {
    question:
      "Can a Shilpkaar be mapped under two Retailers? What is the process for the same?",
    answer: `In this case, you can register on the app HUMBEE by selecting Dealer.
        -	Shilpkaar can purchase the material from multiple sources of Dealers & Retailers. 
    -	For this, you have to search all Shilpkaar through mobile number, if it is present on app, you can sell the materials as explained above in Q 10, otherwise you can register him as a new Shilpkaar. 
        `,
  },
  {
    question:
      "Can a Retailer can be mapped under one dealer or multiple dealers.",
    answer: `Retailers can take material from many dealers for same brand or different brand, you have to search the  Retailer through his mobile number.
        `,
  },
  {
    question:
      "What are the benefits am going to get after starting to use the app?",
    answer: `-	The benefits of the program is on aggregation level. 
        -	I.e.  You can use any Company’s cement   & you will get benefits of all the cement purchased by you  .  
        -	For more scheme benefits , you can give missed call to our call centre 18002100123 .
        `,
  },
  {
    question: "can I use the app in multiple mobile phones with same login?",
    answer: `-	No you can’t use the same app in multiple mobiles with the same login. 
        -	This feature will be updated soon.
        `,
  },
  {
    question: " Does it cost anything to use the mobile app?",
    answer: `- HUMBEE app doesn’t cost you anything and it is absolutely free.
        `,
  },
  {
    question:
      "I’m using multiple accounts. Can I see them all together in mobile app?",
    answer: `-	No, you have to register with one mobile number.
        `,
  },
  {
    question: "How do I update my profile on the app?",
    answer: `You can edit your Profile by login into the APP. 
        `,
  },
  {
    question: "What happens if the app doesn't record the orders placed by me?",
    answer: `-	In such a scenario, please give a missed call at our call centre on 18002100123 and we would be Happy to Help 
        `,
  },
  {
    question: "What happens if I login through unregistered device?",
    answer: `-	You have to register on app only through mobile no.
        `,
  },
  {
    question: "How do I change city, district or state mapped wrongly?",
    answer: `-	In such a scenario, please give a missed call at our call centre on 18002100123 and we would be Happy to Help
        `,
  },
  {
    question: "My Retailers or Shilpkars are not getting OTP for registration.",
    answer: `Call at our call centre on 18002100123 or write a mail Humbee.care@20p95.com 
        `,
  },
  {
    question:
      "Can I specify which authentication method to be used by the mobile app?",
    answer: `You can create your own password in case you don’t want to login through OTP  every time. 
        `,
  },
  {
    question:
      "Already have a version of HUMBEE app on my phone, so do I need to download this new version?",
    answer: `No. It will be required your permission to update the APP through Notification
        `,
  },
  {
    question: "How do I activate the notifications on my phone?",
    answer: `Currently we are working on notification feature, will soon update you about the same 
        `,
  },
];
